const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');

const feesHost = publicConfig.external_address;

exports.Fees = {
  createBillingAddress: (accessToken, ssoId, payload, callback) => {
    const requestParams = {
      host: feesHost,
      path: `/v1/fees/profiles/${ssoId}/BILLING`,
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpLib.request(requestParams, (response) => {
      callback(response);
    }, payload);
  },

  fetchAddress: (accessToken, ssoId, type, callback) => {
    const requestParams = {
      host: feesHost,
      path: `/v1/fees/profiles/${ssoId}/${type}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpLib.request(requestParams, (response) => {
      callback(response);
    }, null);
  },

  fetchAllFeeProfiles: (accessToken, ssoId, callback) => {
    const requestParams = {
      host: feesHost,
      path: `/v1/fees/profiles/${ssoId}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpLib.request(requestParams, (response) => {
      callback(response);
    }, null);
  },

  fetchRegionalFees: (accessToken, payload, callback) => {
    const requestParams = {
      host: feesHost,
      path: '/v1/fees/types/regional',
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    httpLib.request(requestParams, (response) => {
      callback(response);
    }, payload);
  },

  fetchAddressById: (accessToken, feeProfileId, callback) => {
    const requestParams = {
      host: feesHost,
      path: `/v1/fees/profiles/profile/${feeProfileId}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpLib.request(requestParams, (response) => {
      callback(response);
    }, null);
  }
};
